import { fromJS } from "immutable";

import TYPE from "../../constants/type";

const initialState = fromJS({
  list: [],
  listById: [],
  listFiltered: [],
  isFetching: false,
  isFetchingAccepted: false,
});

export default function otherWorkReducer(state = initialState, action) {
  switch (action.type) {
    case TYPE.OTHER_WORK.GET_ALL_OTHER_WORK_LOADING:
    case TYPE.OTHER_WORK.GET_FILTERED_OTHER_WORK_LOADING:
    case TYPE.OTHER_WORK.GET_ALL_OTHER_WORK_BY_PROFILE_ID_LOADING:
    case TYPE.OTHER_WORK.INSERT_OTHER_WORK_LOADING:
    case TYPE.OTHER_WORK.UPDATE_OTHER_WORK_LOADING:
    case TYPE.OTHER_WORK.DELETE_OTHER_WORK_LOADING:
      return state.merge({
        isFetching: true,
      });

    case TYPE.OTHER_WORK.ACCEPT_OTHER_WORK_LOADING:
      return state.merge({
        isFetchingAccepted: true,
      });

    case TYPE.OTHER_WORK.GET_ALL_OTHER_WORK_FAILURE:
    case TYPE.OTHER_WORK.GET_FILTERED_OTHER_WORK_FAILURE:
    case TYPE.OTHER_WORK.GET_ALL_OTHER_WORK_BY_PROFILE_ID_FAILURE:
    case TYPE.OTHER_WORK.INSERT_OTHER_WORK_FAILURE:
    case TYPE.OTHER_WORK.UPDATE_OTHER_WORK_FAILURE:
    case TYPE.OTHER_WORK.DELETE_OTHER_WORK_FAILURE:
      return state.merge({
        isFetching: false,
      });

    case TYPE.OTHER_WORK.ACCEPT_OTHER_WORK_FAILURE:
      return state.merge({
        isFetchingAccepted: false,
      });

    case TYPE.OTHER_WORK.GET_ALL_OTHER_WORK_SUCCESS:
      return state.merge({
        list: action.payload || [],
        isFetching: false,
      });

    case TYPE.OTHER_WORK.GET_FILTERED_OTHER_WORK_SUCCESS:
      return state.merge({
        listFiltered: action.payload || [],
        isFetching: false,
      });

    case TYPE.OTHER_WORK.GET_ALL_OTHER_WORK_BY_PROFILE_ID_SUCCESS:
      return state.merge({
        listById: [...action.payload],
        isFetching: false,
      });

    case TYPE.OTHER_WORK.INSERT_OTHER_WORK_SUCCESS: {
      const newlistById = state.get("listById");
      const index = action.payload.otherWorkProfile.findIndex((e) => e.profileId === action.id);
      if (index >= 0) newlistById.push({ otherWork: action.payload });
      return state.merge({
        listById: [...newlistById],
        listFiltered: [...state.get("listFiltered"), { otherWork: action.payload }],
        isFetching: false,
      });
    }

    case TYPE.OTHER_WORK.UPDATE_OTHER_WORK_SUCCESS: {
      const newList = state.get("listFiltered");
      const index = newList.findIndex((e) => e.otherWork.id === action.id);
      newList.splice(index, 1, { otherWork: action.payload });

      const newList1 = state.get("listById");
      const index1 = newList1.findIndex((e) => e.otherWork.id === action.id);
      newList1.splice(index1, 1, { otherWork: action.payload });

      return state.merge({
        listFiltered: [...newList],
        listById: [...newList1],
        isFetching: false,
      });
    }

    case TYPE.OTHER_WORK.DELETE_OTHER_WORK_SUCCESS: {
      const newList = state.get("listFiltered");
      const index = newList.findIndex((e) => e.otherWork.id === action.id);
      if (index !== -1) newList.splice(index, 1);

      const newList1 = state.get("listById");
      const index1 = newList1.findIndex((e) => e.otherWork.id === action.id);
      if (index1 !== -1) newList1.splice(index1, 1);

      return state.merge({
        listFiltered: [...newList],
        listById: [...newList1],
        isFetching: false,
      });
    }

    case TYPE.OTHER_WORK.ACCEPT_OTHER_WORK_SUCCESS: {
      const newList = state.get("listById");
      const index = newList.findIndex((e) => e.otherWork.id === action.payload.id);
      const newOtherWork = { ...newList[index], otherWork: action.payload };
      newList.splice(index, 1, newOtherWork);

      const newList1 = state.get("listFiltered");
      const index1 = newList1.findIndex((e) => e.otherWork.id === action.payload.id);
      const newOtherWork1 = { ...newList1[index1], otherWork: action.payload };
      newList1.splice(index1, 1, newOtherWork1);

      return state.merge({
        listById: [...newList],
        listFiltered: [...newList1],
        isFetchingAccepted: false,
      });
    }

    default:
      return state;
  }
}

